import React from "react";
import { FormikProps, FieldArray } from "formik";
import { DrawerFormValues } from "src/models/Drawer.model";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { useNavigate } from "react-router-dom";
import { handleValidNumber2 } from "src/utils/formUtils/ValidNumber";

type Props = {
  formikProps: FormikProps<DrawerFormValues>;
  isOut?: boolean;
  title: string;
};

const DrawerInOutFlowForm = ({ formikProps, isOut = false, title }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const navigate = useNavigate();

  // const handleQuantityChange = (
  //   index: number,
  //   e: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const value = e.target.value;

  //   if (value === "" || /^\d*$/.test(value)) {
  //     const available = Number(values.notes[index].availableQuantity || 0);
  //     const numericValue = value === "" ? 0 : Number(value);

  //     if (value === "" || (numericValue >= 0 && numericValue <= available)) {
  //       const newNotes = [...values.notes];
  //       newNotes[index] = {
  //         ...newNotes[index],
  //         quantity: value,
  //       };
  //       setFieldValue("notes", newNotes);
  //     }
  //   }
  // };

  return (
    <div className="p-4 space-y-4 border rounded-md m-4">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium text-slate-700">{title}</div>
        <button
          type="button"
          className="hover:bg-hover"
          onClick={() => navigate("/drawer")}
        >
          Cancel
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="border px-4 py-2">Note Value</th>
              <th className="border px-4 py-2">Quantity</th>
              <th className="border px-4 py-2">Total Amount</th>
            </tr>
          </thead>
          <tbody>
            <FieldArray name="notes">
              {() =>
                values.notes.map((note, index) => {
                  const availableQty = Number(note.availableQuantity || 0);
                  const isDisabled = availableQty === 0;
                  const quantityValue = note.quantity || "";

                  return (
                    <tr key={index}>
                      <td className="border px-4 py-2">{note.name} X</td>
                      <td className="border px-4 py-2">
                        <ATMTextField
                          name={`notes[${index}].quantity`}
                          value={values.notes[index].quantity}
                          disabled={isDisabled && isOut}
                          onChange={(e) =>
                            handleValidNumber2(e) &&
                            setFieldValue(
                              `notes[${index}].quantity`,
                              e.target.value
                            )
                          }
                          placeholder="Enter quantity"
                          onBlur={handleBlur}
                        />

                        {isOut && (
                          <div className="text-[12px] mt-1 flex justify-end ">
                            {isDisabled ? (
                              <span className="text-red-400">
                                Not available
                              </span>
                            ) : (
                              <span>
                                Total available quantity {availableQty}
                              </span>
                            )}
                          </div>
                        )}
                      </td>
                      <td className="border px-4 py-2">
                        {note.value * Number(quantityValue || 0)}
                      </td>
                    </tr>
                  );
                })
              }
            </FieldArray>
          </tbody>
        </table>
      </div>

      <ATMTextArea
        required
        name="reason"
        label="Reason"
        placeholder="Enter reason"
        value={values.reason}
        onChange={(e) => setFieldValue("reason", e)} // Fixed onChange
      />

      <ATMLoadingButton type="submit" isLoading={isSubmitting}>
        Submit
      </ATMLoadingButton>
    </div>
  );
};

export default DrawerInOutFlowForm;
